export const USER_PROFILE_SUCCESS = "USER_PROFILE_SUCCESS";
export const USER_PROFILE_REQUEST = "USER_PROFILE_REQUEST";
export const USER_PROFILE_FAILURE = "USER_PROFILE_FAILURE";
export const REMOVE_FROM_USERS_STORE_REQUEST = "REMOVE_FROM_USERS_STORE_REQUEST";
export const GET_CITY_FROM_PINCODE_REQUEST = "GET_CITY_FROM_PINCODE_REQUEST";
export const GET_CITY_FROM_PINCODE_SUCCESS = "GET_CITY_FROM_PINCODE_SUCCESS";
export const GET_CITY_FROM_PINCODE_FAILURE = "GET_CITY_FROM_PINCODE_FAILURE";
export const CITIES_LIST_REQUEST = "CITIES_LIST_REQUEST";
export const CITIES_LIST_FAILURE = "CITIES_LIST_FAILURE";
export const CITIES_LIST_SUCCESS = "CITIES_LIST_SUCCESS";
export const RESET_USERS_STORE_REQUEST = "RESET_USERS_STORE_REQUEST";
export const RESET_USERS_STORE_SUCCESS = "RESET_USERS_STORE_SUCCESS";
export const GET_USER_PROFILE_BY_ID_REQUEST = "GET_USER_PROFILE_BY_ID_REQUEST"
export const GET_USER_PROFILE_BY_ID_SUCCESS = "GET_USER_PROFILE_BY_ID_SUCCESS";
export const GET_USER_PROFILE_BY_ID_FAILURE = "GET_USER_PROFILE_BY_ID_FAILURE";
export const SIGN_OUT_USER = "SIGN_OUT_USER";
export const SIGN_OUT_REQUEST = "SIGN_OUT_REQUEST";
export const USER_WALLRT_APPLICABLE = "USER_WALLRT_APPLICABLE";
export const GST_VALIDATION_REQUEST = "GST_VALIDATION_REQUEST";
export const GST_VALIDATION_SUCCESS = "GST_VALIDATION_SUCCESS"
export const GST_VALIDATION_FAILURE = "GST_VALIDATION_FAILURE";